import { render, staticRenderFns } from "./AlertData.vue?vue&type=template&id=6eb27315&"
import script from "./AlertData.vue?vue&type=script&lang=js&"
export * from "./AlertData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports